module.exports = __webpack_public_path__ + "img/Nepal.f2d56748.svg";